module.exports = __webpack_public_path__ + "img/logo-smith-nephew-global.ffac0230.jpg";